import React from 'react'
import { BsArrowRightCircle } from "react-icons/bs";

import './ClubResource.css'

function ClubResource({ resources }) {
  return (
    <div className='clubResources'>
        <div className='clubResources__container'>
            {resources.length > 0 ? resources.map((eve, id) => (
                    <div className='cr__card' key={id}>
                        <div className='cr__content'>
                            <img src='https://upload.wikimedia.org/wikipedia/commons/3/3a/Book-icon-bible.png' alt="Resource" />
                            <p>{eve.title}</p>
                            <a href={eve.link} target="_blank" rel="noreferrer">
                                <BsArrowRightCircle className='cr__icon'/>
                            </a>
                        </div>
                    </div>
            )) : <p className='about__p'>No resources added yet</p>}
        </div>
    </div>
  )
}

export default ClubResource